/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartGauge = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11 2v6h1a4 4 0 1 1-4 4v-1H2v1c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2zm2 2.062.226.031A8.001 8.001 0 0 1 12 20l-.25-.004a8.002 8.002 0 0 1-7.657-6.77L4.062 13h2.022l.017.102A6.002 6.002 0 0 0 18 12l-.004-.225a6.002 6.002 0 0 0-4.894-5.674L13 6.084z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartGauge as ChartGauge };
